import * as React from 'react';
import type { SVGProps } from 'react';

const IconEnvelopeWithMoney = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 41" {...props}>
    <path
      d="M1.106 15.643a.603.603 0 0 1-.606-.606V10.97A2.769 2.769 0 0 1 3.262 8.2h6.563c.337 0 .606.269.606.606a.603.603 0 0 1-.606.607H3.262c-.856 0-1.55.7-1.55 1.556v4.068a.607.607 0 0 1-.606.606ZM34.085 14.712a.603.603 0 0 1-.606-.606v-3.137c0-.857-.7-1.557-1.556-1.557h-1.944a.603.603 0 0 1-.606-.606c0-.337.269-.606.606-.606h1.944a2.774 2.774 0 0 1 2.768 2.769v3.137a.603.603 0 0 1-.606.606Z"
      fill="#6D686E"
    />
    <path
      d="M29.13 14.712a.61.61 0 0 1-.463-.212.611.611 0 0 1 .069-.857l2.643-2.237L23.755 2.4l-2.463 2.088a.606.606 0 0 1-.856-.07.606.606 0 0 1 .069-.855L23.43 1.08a.606.606 0 0 1 .856.07l8.412 9.93a.611.611 0 0 1-.069.856l-3.106 2.631a.602.602 0 0 1-.393.144Z"
      fill="#F32A52"
    />
    <path
      d="M3.569 14.712a.606.606 0 0 1-.394-1.069L18.243.881a.606.606 0 0 1 .856.07l8.412 9.93a.606.606 0 0 1-.069.856L24.1 14.568a.617.617 0 0 1-.856-.069.611.611 0 0 1 .068-.856l2.881-2.437-7.63-9.006L3.956 14.568a.575.575 0 0 1-.387.144Z"
      fill="#F32A52"
    />
    <path
      d="M38.812 31.986H27.975a5.083 5.083 0 0 1-3.613-1.493 5.073 5.073 0 0 1-1.5-3.613 5.112 5.112 0 0 1 5.107-5.106h10.843c.05 0 .143 0 .256.037a.606.606 0 0 1-.281 1.175H27.975a3.898 3.898 0 0 0-3.894 3.894c0 1.037.406 2.019 1.144 2.756a3.876 3.876 0 0 0 2.756 1.137h10.824a.607.607 0 0 1 .282 1.175.891.891 0 0 1-.275.038Z"
      fill="#6D686E"
    />
    <path
      d="M28.136 29.868a2.991 2.991 0 0 1-2.987-2.988 2.991 2.991 0 0 1 2.987-2.987 2.991 2.991 0 0 1 2.987 2.987 2.991 2.991 0 0 1-2.987 2.988Zm0-4.763c-.981 0-1.775.794-1.775 1.775 0 .981.794 1.775 1.775 1.775a1.774 1.774 0 1 0 0-3.55Z"
      fill="#F32A52"
    />
    <path
      d="M37.042 40.736H2.944A2.447 2.447 0 0 1 .5 38.292V14.106c0-.337.269-.606.606-.606h35.935a2.447 2.447 0 0 1 2.444 2.444v22.348a2.443 2.443 0 0 1-2.444 2.444ZM1.714 14.712v23.58c0 .681.55 1.231 1.23 1.231h34.099a1.23 1.23 0 0 0 1.231-1.23v-22.35a1.23 1.23 0 0 0-1.231-1.23H1.713Z"
      fill="#6D686E"
    />
  </svg>
);
export default IconEnvelopeWithMoney;
